const data = [
  { name: 'PAL', text: 'PART OF PAL', mostUsed: true },
  { name: 'PAK', text: 'PART OF PAK', mostUsed: true },
  { name: 'Y032', text: '338/97/7' },
  { name: 'Y069', text: 'GOODS NOT FROM IRAN', mostUsed: true },
  { name: 'Y900', text: "NOT IN 'CITIES'", mostUsed: true },
  { name: 'Y901', text: 'NOT DUAL-USED GOODS ', mostUsed: true },
  { name: 'Y904', text: '0775/2014', mostUsed: true },
  { name: 'Y909', text: '1984/2003' },
  { name: 'Y912', text: '194/2008' },
  { name: 'Y916', text: 'R649/2012 1 PRD' },
  { name: 'Y917', text: 'R649/2012 V PRD' },
  { name: 'Y918', text: 'R649/2012 IIIPRD' },
  { name: 'Y922', text: '1523/2007', mostUsed: true },
  { name: 'Y923', text: '1013/2006', mostUsed: true },
  { name: 'Y924', text: 'SU R852/2017 ' },
  { name: 'Y925', text: 'EK PRODUCTS PAGAL R852/17 3str 3d' },
  { name: 'Y926', text: '0517/2014', mostUsed: true },
  { name: 'Y927', text: '1005/2008' },
  { name: 'Y928', text: '1533/2021' },
  { name: 'Y929', text: '848/2018' },
  { name: 'Y930', text: '632/2021' },
  { name: 'Y934', text: '258/2012' },
  { name: 'Y935', text: 'UNUSED R1332/2013 (OL L 335)', mostUsed: true },
  { name: 'Y936', text: 'UNUSED R2014/88/ES (OL L 45)' },
  { name: 'Y937', text: '1793/2019' },
  { name: 'Y938', text: '852/2014' },
  { name: 'Y939', text: 'UNUSED R833/2014, II PRIEDAS' },
  { name: 'Y942', text: '1141/2016' },
  { name: 'Y949', text: '267/2012', mostUsed: true },
  { name: 'Y950', text: 'NOT HIDROFLUOR ' },
  { name: 'Y952', text: 'UNUSED R44/2016 2STR 1 A' },
  { name: 'Y053', text: '44/2016' },
  { name: 'Y955', text: 'UNUSED R517/2014 7STR 2' },
  { name: 'Y956', text: 'NETAIKOMI R517/2014 15 REIKALAVIMAI' },
  { name: 'Y996', text: 'UNUSED R833/14 3B 1 DRAUDIMAI' },
];

const nrPlates = [
  { shortNr: 'XYZ:123', fullNr: 'MAN/XYZ123' },
  { shortNr: 'ABC:456', fullNr: 'MAN/ABC456' },
  { shortNr: 'DEF:789', fullNr: 'MAN/DEF789' },
  { shortNr: 'GHI:234', fullNr: 'MAN/GHI234' },
  { shortNr: 'JKL:567', fullNr: 'SCANIA/JKL567' },
  { shortNr: 'MNO:890', fullNr: 'DAF/MNO890' },
  { shortNr: 'PQR:123', fullNr: 'DAF/PQR123' },
  { shortNr: 'STU:456', fullNr: 'DAF/STU456' },
  { shortNr: 'VWX:789', fullNr: 'DAF/VWX789' },
  { shortNr: 'YZA:123', fullNr: 'SCANIA/YZA123' },
  { shortNr: 'BCD:456', fullNr: 'DAF/BCD456' },
];

const sameText = 'NOT USING REGL.';

export { data, sameText, nrPlates };
